import script from "./HoldingDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./HoldingDetailsPage.vue?vue&type=style&index=0&id=604814f2&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604814f2"]])

export default __exports__